"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { PageWrapper } from "@/components/page-wrapper";
import { ProducerFormDialogButton } from "@/components/producers/producer-form-dialog";
import { ProducersPageContent } from "@/components/producers/producers-list/producers-page-content";
import { FiltersSkeleton } from "@/components/skeleton/filters-skeleton";
export default function ProducersPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProducerFormDialogButton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PageWrapper actions={t0} title="Produtores"><Suspense fallback={<FiltersSkeleton />}><ProducersPageContent /></Suspense></PageWrapper>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}